import OnlyHeader from "components/Headers/OnlyHeader";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import {
  disputeSearchByIdAction,
  getAllDisputes,
} from "store/actions/disputesAction";
import ViewDisputeActivity from "../components/Modals/disputesModal/ViewDisputeActivity";
const Disputes = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { allDisputes, totalPages, getDisputesLoader } = useSelector(
    (state) => state.disputes
  );
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [disputeSearchId, setDisputeSearchId] = useState("");
  const [singleDispute, setSingleDispute] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const itemsPerPage = 10;
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleOnSumbit = () => {
    setCurrentPage(1);
    dispatch(disputeSearchByIdAction(disputeSearchId, currentPage));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  // format the date and time
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    });

    return formattedDate;
  };

  useEffect(() => {
    dispatch(getAllDisputes(selectedOption, currentPage, itemsPerPage));
  }, [dispatch, selectedOption, currentPage, itemsPerPage]);

  const handleClearSearch = () => {
    setDisputeSearchId("");
    dispatch(getAllDisputes(currentPage, itemsPerPage));
  };

  return (
    <>
      <ViewDisputeActivity
        modal={modal}
        toggle={toggleModal}
        singleDispute={singleDispute}
      />

      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row className="mb-5">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="d-flex flex-column justify-content-between align-items-center align-items-lg-start flex-xl-row">
                  <Col className="d-flex justify-content-between align-items-center col-12 col-xl-5">
                    <h3 className="text-center text-xl-left">Disputes</h3>
                    <FormGroup className="mb-xl-0">
                      <Input
                        type="select"
                        name="select"
                        id="exampleSelect"
                        value={selectedOption}
                        onChange={handleSelectChange}
                      >
                        <option value="">All</option>
                        <option value="opened">Opened</option>
                        <option value="closed">Closed</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col className="d-flex flex-column flex-lg-row justify-content-around align-items-center align-items-lg-start">
                    <div className="w-100 w-sm-50">
                      <FormGroup className="mb-0 w-100">
                        <Input
                          id="userSearch"
                          name="Search"
                          placeholder="Search Here..."
                          type="text"
                          value={disputeSearchId}
                          onChange={(e) => setDisputeSearchId(e.target.value)}
                          // bsSize="sm"
                          // className="py-3"
                        />
                      </FormGroup>
                      <small className="text-xs text-primary">
                        Search by Order ID
                      </small>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        className="px-3 py-2 mx-2 my-2 my-lg-0"
                        disabled={getDisputesLoader}
                        onClick={handleOnSumbit}
                        size="sm"
                      >
                        Search
                      </Button>
                      <Button
                        color="primary"
                        className="p-2 mx-2 my-2 my-lg-0"
                        onClick={handleClearSearch}
                        size="sm"
                        disabled={getDisputesLoader}
                      >
                        Clear Search
                      </Button>
                    </div>
                  </Col>
                </Row>
                {/* <div className="d-lg-flex justify-content-between align-items-center">
                  <h3>Disputes</h3>
                  <Row className="align-items-center">
                    <Col xs={8} className="pr-lg-0">
                      <FormGroup className="mb-lg-0">
                        <Input
                          id="disputesSearch"
                          name="Search"
                          placeholder="Search...."
                          type="text"
                          value={disputeSearchId}
                          onChange={(e) => setDisputeSearchId(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={4} className="px-lg-0 text-lg-center text-right">
                      <Button
                        color="primary"
                        className="mb-lg-0 mb-4 px-3"
                        onClick={handleOnSumbit}
                      >
                        Search
                      </Button>
                    </Col>
                  </Row>
                </div> */}
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Order ID</th>
                    <th scope="col">Created At</th>
                    <th scope="col">Updated At</th>
                    <th scope="col">Buyer Name</th>
                    <th scope="col">Seller Name</th>
                    <th scope="col">Opened By</th>
                    <th scope="col">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {!getDisputesLoader ? (
                  <tbody>
                    {allDisputes && allDisputes?.length > 0 ? (
                      allDisputes?.map((dispute, index) => (
                        <tr key={index}>
                          <td>{dispute?.orderId?.orderId}</td>
                          <td>{formatTimestamp(dispute?.createdAt)}</td>
                          <td>{formatTimestamp(dispute?.updatedAt)}</td>
                          <td>
                            {dispute?.buyer?.firstName +
                              " " +
                              dispute?.buyer?.lastName}
                          </td>
                          <td>
                            {dispute?.seller?.firstName +
                              " " +
                              dispute?.seller?.lastName}
                          </td>
                          <td className="text-capitalize">
                            <div
                              className="text-truncate"
                              style={{ maxWidth: "200px" }}
                            >
                              {dispute?.type}
                            </div>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                dispute?.isResolved
                                  ? "badge-success"
                                  : "badge-danger"
                              }`}
                            >
                              {dispute?.isResolved ? "Closed" : "Open"}
                            </span>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              color="primary"
                              onClick={() => {
                                // toggleModal();
                                // setSingleDispute(dispute);
                                history.push(
                                  `/admin/disputes-details/${dispute?._id}`
                                );
                              }}
                            >
                              View Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          <p className="mb-0 text-sm">No Disputes found.</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center" }}>
                        <Spinner
                          size="lg"
                          style={{ display: "block", margin: "0 auto" }}
                        />
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageChange}
                      containerClassName={
                        "pagination px-1 justify-content-end mb-0"
                      }
                      activeClassName={"active"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      nextClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextLinkClassName={"page-link"}
                    />
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Disputes;
